"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const export_data_1 = require("./export-data");
function exportState({ data, }) {
    return (state, actions) => () => {
        return export_data_1.exportData.export(data, state);
    };
}
exports.exportState = exportState;
//# sourceMappingURL=export-state.js.map